import { useState } from "react";

import { Grid, makeStyles, Typography } from "@material-ui/core";

import { Icon } from "../base/Icon";
import { ModalBox } from "../boxes/ModalBox";
import RemoveIcon from "../../assets/images/icons/remove.svg";
import { ButtonsGroup } from "../buttonsGroup";
import { RadioButtonsGroup } from "../buttonsGroup/RadioButtonsGroup";

const FORMATS = ["Excel", "PDF", "PPT"];

const useStyles = makeStyles((theme) => ({
  selectFormat: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}));

export const ExportDataModal = ({ onClose }) => {
  const classes = useStyles();
  const [format, setFormat] = useState(FORMATS[0]);

  const onFormatSelected = (format) => {
    setFormat(format);
  };

  return (
    <ModalBox width={500}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h2">Export Data</Typography>
        <Icon src={RemoveIcon} hoverable onClick={onClose} />
      </Grid>
      <Typography variant="subtitle1" className={classes.selectFormat}>
        Select format:
      </Typography>
      <RadioButtonsGroup
        options={FORMATS}
        selectedValue={format}
        onChange={onFormatSelected}
      />
      <ButtonsGroup
        buttons={[{ text: "EXPORT" }, { text: "CANCEL", onClick: onClose }]}
      />
    </ModalBox>
  );
};
